<div>
  <ngx-loading [show]="loading" aria-live="polite"></ngx-loading>
</div>
<mat-card class="reset-panel">
  <mat-card-header>
    <mat-card-title>Reset Password</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form #passwordForm="ngForm">
      <mat-form-field>
        <input matInput placeholder="Password" [(ngModel)]="password" type="password" name="password"
          (change)="validatePassword(password)" required>
      </mat-form-field>

      <mat-form-field>
        <input matInput placeholder="Confirm Password" [(ngModel)]="passwordConfirm" type="password"
          name="resetPassword" required>
      </mat-form-field>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <button mat-raised-button (click)="resetPassword()" color="primary" [disabled]="!isValidPassword()">Reset
      Password</button>
  </mat-card-actions>
</mat-card>
<mat-card class="reset-panel">
  <b>Passwords must have:</b>
  <ul>
    <li>at least 8 characters</li>
    <li>at least one UPPERCASE letter</li>
    <li>at least one lowercase letter</li>
    <li>at least one non-alpha character (0-9 or any special characters)</li>
  </ul>
</mat-card>
